import { FindWorkflowQuery, WorkflowContainerFragment } from 'generated/resources/graphql'

interface GetWorkflowResult {
  workflow: WorkflowContainerFragment | undefined
  hasWorkflowChanges: boolean
  isLastWorkflowVersionPublished: boolean
}

export function getWorkflow(
  workflowsData?: FindWorkflowQuery,
  isDirty?: boolean
): GetWorkflowResult {
  // Extract the workflow and manifest from the workflow query
  const workflows: WorkflowContainerFragment[] =
    workflowsData?.workflows?.workflowsConnection?.nodes || []

  const lastWorkflow = workflows.sort((a, b) => b.version - a.version)[0]
  const activeWorkflow = workflows.find((x) => x.status === 'active')

  const activeWorkflowVersion = activeWorkflow?.version
  const lastWorkflowVersion = lastWorkflow?.version

  const workflow = lastWorkflow || activeWorkflow || undefined

  return {
    workflow,
    hasWorkflowChanges: isDirty || false,
    isLastWorkflowVersionPublished: activeWorkflowVersion === lastWorkflowVersion,
  }
}
